// @ts-expect-error: react-leaflet-arrowheads is not typed: https://github.com/slutske22/react-leaflet-arrowheads/issues/4
import Polyline from "react-leaflet-arrowheads"
import { shallowEqual } from "react-redux"

import { useAppSelector } from "@/App"
import colors from "@/scss/colors.module.scss"
import { selectOrdersByDriverId } from "@/store/orders"
import { Driver, OrderPoint } from "@/types"
import { getDatetimeSortValue, OrderUtils } from "@/utils"

export function sortTasksByArrivedTime(a: OrderPoint, b: OrderPoint) {
  const valueA = a.arrived_at || a.estimated_time
  const valueB = b.arrived_at || b.estimated_time

  return getDatetimeSortValue(valueB, valueA)
}

function filterDriverHistoryTasks(task: OrderPoint | null) {
  return task && ["finished", "in_progress"].includes(task.state)
}

export const DriverTasksRouteHistory = ({ driverId }: { driverId: Driver["id"] }) => {
  const orders = useAppSelector(selectOrdersByDriverId(driverId), shallowEqual)

  const tasks = orders.flatMap(OrderUtils.getOrderPoints).filter(filterDriverHistoryTasks).sort(sortTasksByArrivedTime)

  if (!tasks) return null

  return (
    <>
      {tasks.map((task, currentIndex, tasks) => {
        const nextTask = tasks[currentIndex + 1]
        if (!nextTask) return null

        return (
          <Polyline
            arrowheads={{ size: "10px", frequency: 2, fill: true }}
            color={colors.muted}
            positions={[
              [task.lat, task.lng],
              [nextTask.lat, nextTask.lng],
            ]}
            key={`driver-history-route-${task.id}`}
          />
        )
      })}
    </>
  )
}
